import React, { useEffect, useContext } from 'react';

import {
  FormContext,
  FormField,
  withFormFieldGroupFormField,
  getIn,
} from '@gogame/form';

import Partner from 'scenes/CustomAudiences/PartnerAudiences/components/PartnerAudienceForm/PartnerAudiencesFieldset/Partner';
import {
  CREDENTIALS,
  INCLUDE_DEPOSIT_VALUES,
  MULTIPLY_DEPOSIT_AMOUNTS,
  PARTNER_DATA,
} from 'scenes/CustomAudiences/PartnerAudiences/components/PartnerAudienceForm/constants';

import {
  AutoSync,
  DataType,
  PartnerName,
  Account,
  Credentials,
} from '../fileds';
import { validationSchema } from './schema';

export const FacebookFieldSet = ({
  value,
  path,
  externalDepends,
  onRemove,
}) => {
  const { values, setFieldValue } = useContext(FormContext);

  const includeDepositValues = getIn(
    values,
    `${path}.${INCLUDE_DEPOSIT_VALUES}`,
    false
  );
  const multiplyDepositAmounts = getIn(
    values,
    `${path}.${PARTNER_DATA}.${MULTIPLY_DEPOSIT_AMOUNTS}`,
    false
  );
  const disabledAccount = !value?.[CREDENTIALS];

  useEffect(() => {
    if (!includeDepositValues && multiplyDepositAmounts) {
      setFieldValue(
        `${path}.${PARTNER_DATA}.${MULTIPLY_DEPOSIT_AMOUNTS}`,
        false
      );
    }
  }, [includeDepositValues]);

  return (
    <Partner
      path={path}
      depends={externalDepends}
      onRemove={onRemove}
      name={<PartnerName path={path} required={true} />}
      autoSync={<AutoSync />}
      credentials={
        <Credentials
          required={true}
          path={path}
          externalDepends={externalDepends}
        />
      }
      fields={[
        <DataType
          required={true}
          path={path}
          externalDepends={externalDepends}
        />,
        <Account
          required={true}
          path={path}
          externalDepends={externalDepends}
          disabled={disabledAccount}
        />,
      ]}
      checkboxes={[
        <FormField.Checkbox
          name={INCLUDE_DEPOSIT_VALUES}
          label={'Include deposits values'}
          helper={'For more accurate Facebook Lookalike audiences'}
          padding={0}
        />,
        <FormField.Checkbox
          active={includeDepositValues}
          name={`${PARTNER_DATA}.${MULTIPLY_DEPOSIT_AMOUNTS}`}
          label={'Multiply deposits amount'}
          helper={'For better understanding for depositors significance'}
          padding={0}
        />,
      ]}
    />
  );
};

export default withFormFieldGroupFormField({
  padding: 0,
  validationSchema: validationSchema,
})(FacebookFieldSet);
